import NewsletterModalButton from './NewsletterModalButton';

export default NewsletterModalButton;
